export const datePickerConfig = {
  data() {
    return {
      datePickerConfig: {
        dateFormat: 'd/m/Y',
        defaultDate: '',
        ariaDateFormat: 'd/m/Y',
      },
    }
  },
}

export const _ = null
